import { render, staticRenderFns } from "./C1R.vue?vue&type=template&id=c29cac22"
import script from "./C1R.vue?vue&type=script&lang=js"
export * from "./C1R.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports